import { useEffect, useMemo, useState } from "react";
import { IPortingSlots, IPortinSlot } from "../IPortinSlot";
import { useFetch } from "@hooks/useFetch";
import { GET_PORT_IN_SLOT_ROUTE } from "@api-routes/mnpFacade";

export const useGetPortinSlot = (isPortinOpen: boolean = true) => {
    const [getPortinSlotState, { get }] = useFetch();
    const [portinSlotList, setPortinSlotList] = useState<IPortinSlot[]>([]);

    const getPortinSlot = useMemo(
        () => () => {
            get<{ portingHours: IPortingSlots[] }>(GET_PORT_IN_SLOT_ROUTE, { isSecured: false }).then((response) => {
                if (response) {
                    const timeRangeWithDate = response.portingHours.map((portingSlot) => ({
                        date: new Date(portingSlot.date),
                        startTime: new Date(portingSlot.startTime),
                        endTime: new Date(portingSlot.endTime),
                    }));

                    setPortinSlotList(timeRangeWithDate);
                }
            });
        },
        [get]
    );

    useEffect(() => {
        if (isPortinOpen) {
            getPortinSlot();
        }
    }, [getPortinSlot, isPortinOpen]);

    return {
        getPortinSlotState,
        portinSlotList,
        getPortinSlot,
    };
};
